var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"spinner-wrapper align-items-center justify-content-center",attrs:{"fluid":""}},[(_vm.loaderId)?_c('half-circle-spinner'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }